import { clearAccessToken, signOut, useAuth } from '../auth'
import { clearSessionCookies } from '../auth/sessionCookies'
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../global_context/GlobalContext';

export default function Logout() {
  const navigate = useNavigate();
  const { clearAuth } = useAuth();
  const { clearUserRole } = useContext(GlobalContext);

  useEffect(() => {
    const run = async () => {
      await signOut();

      clearSessionCookies();
      clearAccessToken();
      clearAuth();
      clearUserRole?.();
      localStorage.removeItem('collapsedState');
      navigate('/?logout=true', { replace: true });
    };

    run();
  }, [navigate, clearAuth, clearUserRole]);

  return <p style={{ padding: 20 }}>Cerrando sesión...</p>;
}
